import { useRef } from "react";
import { Link } from "react-router-dom";
import useOutsideAlerter from "../../hooks/useOutsideAlerter";

const MobileNav = () => {

    const mobilenavRef = useRef(null);
    
    const hideMobileNav = () => {
        document.querySelector('.mobile_nav').classList.remove('show');
    }
    
    useOutsideAlerter(mobilenavRef, hideMobileNav);

    const toggleMobileDropdown = (number) => {
        for(let i = 1; i <= 2; i++){
            document.querySelector(`.mobile_dropdown_menu_${i}`).classList.remove('show');
            document.querySelector(`.mobile_dropdown_${i} button`).classList.remove('active');    
        }
        document.querySelector(`.mobile_dropdown_menu_${number}`).classList.toggle('show');
        document.querySelector(`.mobile_dropdown_${number} button`).classList.toggle('active');
    }

    return(
        <div ref={mobilenavRef} className="lg:hidden mobile_nav fixed top-0 right-0 w-full h-[100vh] max-w-[400px] z-[9] bg-[#1F1D2B]">
            <button className="absolute z-[11] top-[3%] left-[5%]" onClick={hideMobileNav}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="h-[30px] w-[30px] text-white" viewBox="0 0 352 512">
                    <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/>
                </svg>
            </button>

            <div className="pt-16 sm:pt-24 px-5 sm:px-8 flex flex-col text-xl h-[100vh] overflow-auto custom_scrollbar">
                <Link onClick = {hideMobileNav} className = 'nav_home nav_link mb-5' to="/">Home</Link>
                <Link onClick = {hideMobileNav} className = 'nav_profile nav_link mb-5' to="/myprofile">My Profile</Link>
                <Link onClick = {hideMobileNav} className = 'nav_howitworks nav_link mb-5' to="/howitworks">How it Works</Link>

                <div className="mobile_dropdown mobile_dropdown_1 bg-[#1f1d2b]">
                    <button className="flex w-full justify-between items-center mb-5" onClick={() => toggleMobileDropdown(1)}>
                        <span className="">Explore</span>
                        <svg fill='currentColor' className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
                    </button>
                    <ul className="mobile_dropdown_menu mobile_dropdown_menu_1 max-h-[0px] overflow-hidden">
                        <li className="">
                            <Link to = '/collections' onClick = {hideMobileNav} className="rounded-t text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">All NFTs</Link>
                        </li>
                        <li className="">
                            <Link to = '/category/art' onClick = {hideMobileNav} className="rounded-t text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Art</Link>
                        </li>
                        <li className="">
                            <Link to = '/category/collectibles' onClick = {hideMobileNav} className="text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Collectibles</Link>
                        </li>
                        <li className="">
                            <Link to = '/category/domainnames' onClick = {hideMobileNav} className="text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Domain Names</Link>
                        </li>
                        <li className="">
                            <Link to = '/category/music' onClick = {hideMobileNav} className="text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Music</Link>
                        </li>
                        <li className="">
                            <Link to = '/category/photography' onClick = {hideMobileNav} className="text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Photography</Link>
                        </li>
                        <li className="">
                            <Link to = '/category/virtualworlds' onClick = {hideMobileNav} className="text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Virtual Worlds</Link>
                        </li>
                        <li className="">
                            <Link to = '/category/sports' onClick = {hideMobileNav} className="text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Sports</Link>
                        </li>
                        <li className="">
                            <Link to = '/category/tradingcards' onClick = {hideMobileNav} className="text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Trading Cards</Link>
                        </li>
                        <li className="">
                            <Link to = '/category/utility' onClick = {hideMobileNav} className="rounded-b nav_sublink text-[16px] py-4 px-5 block whitespace-no-wrap">Utility</Link>
                        </li>

                    </ul>
                </div>

                <div className="mobile_dropdown mobile_dropdown_2 ">
                    <button className="flex w-full justify-between items-center " onClick={() => toggleMobileDropdown(2)}>
                        <div className="flex items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" fill='currentColor' className='w-[14px] h-[14px]' viewBox="0 0 512 512">
                                <path d="M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"/>
                            </svg>
                            <span className="mx-2">Profile</span>
                        </div>
                        <svg fill='currentColor' className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
                    </button>
                    <ul className="mobile_dropdown_menu mobile_dropdown_menu_2 bg-[#1f1d2b] max-h-[0px] overflow-hidden">
                        <li className="">
                            <Link to = '/myprofile' className="rounded-t text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Profile</Link>
                            <Link to = '/activity' className="rounded-t text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Activity</Link>
                            <Link to = '/collections' className="rounded-t text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Favorite</Link>
                            <Link to = '/collections' className="rounded-t text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Watchlist</Link>
                            <Link to = '/collections' className="rounded-t text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">My Collections</Link>
                            <Link to = '/myprofile' className="rounded-t text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Settings</Link>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    )
}

export default MobileNav;